<template>
    <router-link :to="`/warriors/${content.id}`">
        <div class="warrior" :class="{'is-hover': isHover}" @mouseover="onMouseOver" @mouseleave="onMouseLeave">
            <div class="warrior__image">
                <AppParallaxeElem :amount="0.1">
                    <AppLazyImg :alt="content.acf.cover_image.alt" :url="content.acf.cover_image.url" :width="content.acf.cover_image.width" :height="content.acf.cover_image.height" :classes="['warrior__image__elem']" />
                </AppParallaxeElem>
            </div>
            <div class="warrior__text" v-if="hasWarrior">
              warrior<span class="warrior__text__number">n°{{ content.acf.number }}</span>
            </div>
            <div class="warrior__overlay__bg"></div>
            <div class="warrior__overlay" :class="{'has-warrior': hasWarrior}" ref="overlay">
                <div class="warrior__overlay__number" v-if="!hasWarrior"> N°{{ content.acf.number }}</div>
                <p class="warrior__overlay__title" v-html="content.acf.displayed_title"></p>
            </div>
        </div>
    </router-link>
</template>

<script>
import EventHub from '@/utils/EventHub'
import getAbsoluteBoundingRect from '@/utils/getAbsoluteBoundingRect.js'

import AppParallaxeElem from '@/components/AppParallaxeElem.vue'
import AppLazyImg from '@/components/AppLazyImg.vue'

export default {
    name: 'AppWarrior',

    components: {
        AppLazyImg,
        AppParallaxeElem
    },

    props: {
        content: {
            type: Object,
            default: null
        },
        hasWarrior: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isHover: false,
            isMobile: false,
        }
    },

    created()
    {
        this.addEventListeners()
    },

    mounted()
    {
        this.onResize({width: window.innerWidth, height: window.innerHeight})
    },

    destroyed()
    {
        this.removeEventListeners()
    },

    methods: {
        addEventListeners()
        {
            EventHub.$on('application:on-scroll', this.onScroll)
            EventHub.$on('application:on-tick', this.onTick)
            EventHub.$on('window:resize', this.onResize)
        },

        removeEventListeners()
        {
            EventHub.$off('application:on-scroll', this.onScroll)
            EventHub.$off('application:on-tick', this.onTick)
            EventHub.$off('window:resize', this.onResize)
        },

        onMouseOver()
        {
            this.onScroll(window.scrollY)
            this.isHover = true
        },

        onMouseLeave()
        {
            this.isHover = false
        },

        onScroll(scrollY)
        {
            this.scrollY = scrollY
        },

        onTick()
        {
            if(this.isHover)
            {
                const initialPos = this.overlayBounds.top
                // Target is middle of the screen
                const targetPos = this.scrollY + this.windowObj.height / 2

                const translateY = targetPos - initialPos

                this.$refs.overlay.style.transform = `translate3d(0, ${translateY}px, 0)`
            }
        },

        onResize(windowObj)
        {
            this.windowObj = windowObj

            if(this.windowObj.width > 768)
            {
                this.isMobile = false
                this.overlayBounds = getAbsoluteBoundingRect(this.$refs.overlay)
            }
            else
            {
                this.isMobile = true
            }
        },
    }
}
</script>

<style lang="stylus">
    .warrior
        overflow hidden
        cursor pointer
        position relative
        width 100%
        height 100%
        // margin-bottom 150px

        // @media(max-width 768px)
        //     margin-bottom 20px

    .warrior__image__elem
        width 100%
        display block
        object-fit cover

    .warrior__text
      z-index 2
      position absolute 
      top 50%
      width 100%
      text-align center
      text-transform uppercase
      color $white
      letter-spacing 0.2em
      font-family 'Sabon'
      transform translateY(-50%)
      interpolate('font-size', 1600px, 2560px, 95px, 122px);

      @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 48px, 95px);

    .warrior__text__number
      position absolute
      top 14px
      font-size 12px
      font-family 'Akzidenz', sans-serif
      font-weight 700
      letter-spacing 0.1em
      interpolate('font-size', 1600px, 2560px, 20px, 25px);

      @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 13px, 20px);
    
    .warrior__overlay
        position absolute
        top 0
        width 100%
        color $grey-light  
        visibility hidden
        transition visibility 0.2s

        @media(max-width 768px)
            top 50%
            transform translateY(-50%)

        .is-hover &
            visibility visible

        &.has-warrior
            top 65%

    .warrior__overlay__bg
        position absolute
        top 0
        width 100%
        height 100%
        background #1a1a1a
        opacity 0
        visibility hidden
        // transition opacity 0.2s $ease-out-quad, visibility 0.2s

        .is-hover &
            visibility visible
            opacity 0.9
            // transition opacity 0.2s $ease-out-quad

    .warrior__overlay__number
        margin-bottom 60px
        font-size 12px
        text-transform uppercase
        text-align center
        opacity 0
        visibility hidden
        // transform translate3d(0, 20px, 0)
        // transition transform 0.2s $ease-out-quad, opacity 0.2s $ease-out-quad

        .is-hover &
            opacity 1
            visibility visible
            // transform translate3d(0, 0, 0)

    .warrior__overlay__title
        max-width 70%
        margin 0 auto
        text-transform uppercase
        text-align center
        font-size 42px
        line-height 1
        opacity 0
        visibility hidden
        interpolate('font-size', 1600px, 2560px, 60px, 84px);

        @media(max-width 1600px)
            interpolate('font-size', 768px, 1600px, 30px, 60px);
        // transform translate3d(0, 40px, 0) scale(0.9)
        // transition transform 0.2s $ease-out-quad, opacity 0.2s $ease-out-quad

        .is-hover &
            opacity 1
            visibility visible
            // transform translate3d(0, 0, 0) scale(1)

        @media(max-width 768px)
            font-size 26px


</style>